export default __webpack_public_path__ + "static/media/SparkyMitra_headshot.5239996a.jpg";